import * as React from 'react';
import clsx from 'clsx';
import { Interactive, Base } from '../Base';
import Spinner from '../Spinner';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ButtonBase-root_r3xHh",
  "slot": "ButtonBase-slot_Csw1g",
  "spinner": "ButtonBase-spinner_Do7SO",
  "shapeDefault": "ButtonBase-shapeDefault_21OT6",
  "shapeCompact": "ButtonBase-shapeCompact_20BTQ",
  "shapeCircle": "ButtonBase-shapeCircle_3o4hl",
  "kindDefault": "ButtonBase-kindDefault_vBGtr",
  "active": "ButtonBase-active_1tBZd",
  "kindOutline": "ButtonBase-kindOutline_2X76w",
  "kindGhost": "ButtonBase-kindGhost_3Owv3",
  "kindLink": "ButtonBase-kindLink_1V-tS",
  "intentDefault": "ButtonBase-intentDefault_3rcno",
  "intentPrimary": "ButtonBase-intentPrimary_3kogC",
  "intentSuccess": "ButtonBase-intentSuccess_2na6u",
  "intentDanger": "ButtonBase-intentDanger_1ot21",
  "heightDefault": "ButtonBase-heightDefault_1Turh",
  "heightSmall": "ButtonBase-heightSmall_323-Y",
  "widthDefault": "ButtonBase-widthDefault_YOV2r",
  "widthSmall": "ButtonBase-widthSmall_2nBCE",
  "grouped": "ButtonBase-grouped_1w1JZ",
  "disabled": "ButtonBase-disabled_2gmTj",
  "loading": "ButtonBase-loading_3DNnc"
};
function ButtonBase({
  kind = 'default',
  shape = 'default',
  intent = 'default',
  small,
  grouped,
  disabled,
  active,
  loading,
  slot: slotProp,
  className,
  children,
  ...extraProps
}, ref) {
  const rootClasses = clsx(styles.root, {
    [styles.kindDefault]: kind === 'default',
    [styles.kindOutline]: kind === 'outline',
    [styles.kindGhost]: kind === 'ghost',
    [styles.kindLink]: kind === 'link',
    [styles.shapeDefault]: kind !== 'link' && shape === 'default',
    [styles.shapeCompact]: kind !== 'link' && shape === 'compact',
    [styles.shapeCircle]: kind !== 'link' && shape === 'circle',
    [styles.intentDefault]: intent === 'default',
    [styles.intentPrimary]: intent === 'primary',
    [styles.intentSuccess]: intent === 'success',
    [styles.intentDanger]: intent === 'danger',
    [styles.heightDefault]: kind !== 'link' && !small,
    [styles.heightSmall]: kind !== 'link' && small,
    [styles.widthDefault]: kind !== 'link' && !small && /compact|circle/.test(shape),
    [styles.widthSmall]: kind !== 'link' && small && /compact|circle/.test(shape),
    [styles.grouped]: grouped,
    [styles.disabled]: disabled,
    [styles.active]: active,
    [styles.loading]: loading
  }, className);
  const slot = loading ? /*#__PURE__*/_jsx(Spinner, {
    name: "dots",
    theme: kind === 'default' ? 'dark' : 'light',
    className: styles.spinner
  }) : slotProp;
  const visibility = /*#__PURE__*/React.isValidElement(slot) ? 'hidden' : undefined;
  return /*#__PURE__*/_jsxs(Interactive, {
    flexInline: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    interactive: true,
    boxSizing: "border",
    position: "relative",
    weight: kind === 'link' ? 'regular' : 'semibold',
    disabled: disabled || loading,
    className: rootClasses,
    innerRef: ref,
    ...extraProps,
    children: [slot && /*#__PURE__*/_jsx(Base, {
      tagName: "span",
      position: "absolute",
      className: styles.slot,
      children: slot
    }), /*#__PURE__*/React.isValidElement(children) && /*#__PURE__*/React.cloneElement(children, {
      visibility
    })]
  });
}
const Export = /*#__PURE__*/React.forwardRef(ButtonBase);
Export.displayName = 'ButtonBase';
export default Export;